-----------------------------------------------------------------------------------------------------------------------------------------------------------
* Componente base *
Chamada: <tagComponentePai v-model="dadoComponentePai"></tagComponentePai>
Retorno: String para data. DD/MM/YYYY ou YYYY-MM-DD
Saída: this.selectedLocal pode ser modificada no watcher de this.time para alteração de formato
* Aceita props *
-----------------------------------------------------------------------------------------------------------------------------------------------------------

<template>
  <div>
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
          <!-- outlined
          filled -->
        <v-text-field
          readonly
          v-model="dateFormatted"
          :label="text"
          append-icon="mdi-clock-time-three-outline"
          v-bind="attrs"
          persistent-hint
          v-on="on"
          :rules="rules"
          color="secondary"
        ></v-text-field>
      </template>
      <v-time-picker v-model="time" @click:minute="$refs.menu1.save(time)" format="24hr" scrollable 
        :min="really_min" :max="really_max"
      ></v-time-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    min_is_today:{
      type: Boolean,
      default: () => false
    },
    min: {
      type: String
    },
    max: {
      type: String
    },
    text: {
      type: String,
      default: "Escolha a data"
    },
    inital_date: {
      type: String
    },
    rules: {
      // Envie como :rules="[ruleRequired('Campo obrigatório!')]" importado de mixins/validations no componente pai.
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: "selected",
    event: "selectedChange"
  },
  data: vm => ({
    time: null,
    dateFormatted: null, //vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.time);
    },
    selectedLocal: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit("selectedChange", value);
      }
    },
    really_min(){
      if (this.min){
        return this.$moment(`2020-01-01T${this.min}`).add(1, 'minute').format('HH:mm')
      }
      return null
    },
    really_max(){
      if (this.max){
        return this.$moment(`2020-01-01T${this.max}`).subtract(1, 'minute').format('HH:mm')
      }
      return null
    }

  },
  mounted() {
    if (this.inital_date){
      this.selectedLocal = this.inital_date
      this.time = this.inital_date
    } else {
      // this.selectedLocal = this.$moment().format('HH:mm')
    }
  },
  methods: {
    formatDate(time) {
      if (!time) return null;

      const [year, month, day] = time.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(time) {
      if (!time) return null;

      const [month, day, year] = time.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  watch: {
    time(val) {
      this.dateFormatted = val// this.formatDate(this.time);
      // Atribua abaixo o valor a ser retornado ao componente pai via this.selectedLocal
      // this.time tem formato YYYY-MM-DD
      // this.dateFormatted tem formato DD/MM/YYYY
      this.selectedLocal = this.time;
    }
  }
};
</script>